import {
	mapState,
	mapActions,
	mapGetters
} from 'vuex';

import moment from 'moment';

import {
	TimeSelect
} from 'element-ui';

import {
	EventBus
} from '@/support/event-bus';

import {
	isEmpty,
	cloneDeep
} from 'lodash';

import toastr from '@/support/toastr';

export default {
	name: 'student-meals',
	components: {
		TimeSelect
	},
	data: () => ({
		additionalMeal: {
			meal: '',
			portion: '',
			time: ''
		}
	}),
	computed: {
		...mapState({
			meals: (state) => state.Agenda.agenda.meals,
			quantityTypes: (state) => state.ENUM.QuantityMealsType
		}),
		...mapGetters({
			additionals: 'getAdditionalMeals',
			date: 'getAgendaDate'
		})
	},
	methods: {
		...mapActions([
			'putAgendaMealPortion',
			'putAgendaBeveragePortion',
			'postAgendaAdditionalMealsItem',
			'putAgendaAdditionalMealsItem',
			'deleteAdditionalMealsItem',
			'putCompletionStatus'
		]),
		completionStatus(model) {

			let status = false;

			if (isEmpty(model.time) && isEmpty(model.meal) && isEmpty(model.portion)) {
				status = true;
			}

			this.putCompletionStatus({
				key: 'additionalMeal',
				value: status
			});

		},
		addAdditionalMealsItem() {

			this.$validator.validateAll().then((valid) => {

				if (valid && this.getTimeDiff(this.additionalMeal.time) > 0) {

					if (this.additionalMeal.index !== undefined && this.additionalMeal.index >= 0) {
						this.putAgendaAdditionalMealsItem(cloneDeep(this.additionalMeal));
					} else {
						this.postAgendaAdditionalMealsItem(cloneDeep(this.additionalMeal));
					}

					this.additionalMeal = {
						meal: '',
						portion: '',
						time: ''
					};

					this.completionStatus(true);

				} else if (this.getTimeDiff(this.additionalMeal.time) <= 0) {
					toastr.warning('O horário da alimentação adicional não pode ser uma data futura.');
				} else {
					toastr.warning('Por favor informar todos os campos relacionados a alimetação adicionais');
				}

			});
		},
		editAdditionalMealsItem(index) {

			this.additionalMeal = cloneDeep(this.additionals[index]);
			this.additionalMeal.index = index;

		},
		getTimeDiff(time) {

			if (time) {

				const [year, month, date] = this.date.split('-');
				const [hour, minute] = time.split(':');

				return moment().diff(
					moment().set({
						year,
						month: (month - 1),
						date,
						hour,
						minute,
						second: 0
					})
				);

			}

		}
	},
	mounted() {

		EventBus.$on('setStudent', () => {

			this.additionalMeal = {
				meal: '',
				portion: '',
				time: ''
			};

		});

	},
	beforeDestroy() {

		EventBus.$off('setStudent');

	}
};



// WEBPACK FOOTER //
// ./sources/domains/agenda/alimentation/meals/index.js